<template>
    <div>
        <UiCardListHeader :title="lang('deployment::deployment.widgets.deployment_info.title')" />

        <UiCard class="mb-2">
            <div class="ui-card__content">
                <div class="ui-card__aside">
                    <div class="ui-badge ui-badge--lg ui-badge--success">
                        {{ info.release }}
                    </div>
                </div>
                <div class="ui-card__body">
                    <table class="ui-info-table">
                        <tbody>
                            <tr>
                                <th scope="row">
                                    {{ lang('deployment::deployment.widgets.deployment_info.info.release') }}
                                </th>
                                <td>
                                    {{ info.release }}
                                    <span v-if="info.age"> ({{ dateTimeHumanReadableFromISO(info.age) }}) </span>
                                </td>
                            </tr>
                            <tr>
                                <th scope="row">
                                    {{ lang('deployment::deployment.widgets.deployment_info.info.version') }}
                                </th>
                                <td>
                                    {{ info.version }}
                                    <span
                                        v-tooltip="{
                                            message: lang(
                                                'deployment::deployment.widgets.deployment_info.info.nickname',
                                            ),
                                            position: 'top',
                                        }"
                                    >
                                        ({{ info.nickname }})
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th scope="row">
                                    {{ lang('deployment::deployment.widgets.deployment_info.info.php') }}
                                </th>
                                <td>
                                    {{ info.php }}
                                </td>
                            </tr>
                            <tr>
                                <th scope="row">
                                    {{ lang('deployment::deployment.widgets.deployment_info.info.laravel') }}
                                </th>
                                <td>
                                    {{ info.laravel }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </UiCard>

        <UiCardEmpty v-if="deploys.length === 0">
            {{ lang('deployment::deployment.widgets.deployment_info.no_deployments') }}
        </UiCardEmpty>
        <UiCardList
            v-else
            as="transition-group"
            name="slide-fade"
            enter-active-class="transition duration-300 ease-out transform"
            enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-20"
            enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
            leave-active-class="transition duration-100 ease-in"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <deploy-preview v-for="deploy in deploys" :key="deploy.id" :deploy="deploy"></deploy-preview>
        </UiCardList>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import DeployPreview from '@src/Deployment/Pages/Deploy/DeployPreview.vue';
import { dateTimeHumanReadableFromISO } from '@src/Common/Helpers/dates';

interface WidgetData {
    deploys?: any[];
    info?: Record<string, unknown>;
}

const props = defineProps<{ slug?: string; settings?: object; data?: WidgetData }>();

const deploys = ref(props.data?.deploys ?? []);

const info = ref(
    props.data?.info ?? {
        nickname: null,
        version: null,
        php: null,
        laravel: null,
        release: null,
        age: null,
    },
);

const load = () => {
    axios.get(route('deployment.admin.api.latest')).then(({ data }) => {
        deploys.value = data.deploys ?? [];
        info.value = data.info ?? {};
    });
};

if (typeof window.Echo !== 'undefined') {
    window.Echo.channel('deployment').listen('.deployment.made', () => {
        load();
    });
}
</script>
